// Small presentation helpers shared across the game screens.

export const POSITION_GROUP = {
  GK: 'GK',
  CB: 'DEF', RB: 'DEF', LB: 'DEF', RWB: 'DEF', LWB: 'DEF',
  DM: 'MID', CM: 'MID', RM: 'MID', LM: 'MID', CAM: 'MID',
  RW: 'FWD', LW: 'FWD', ST: 'FWD',
};

export const GROUP_ORDER = ['GK', 'DEF', 'MID', 'FWD'];

export const GROUP_LABEL = {
  GK: 'Goalkeepers', DEF: 'Defenders', MID: 'Midfielders', FWD: 'Forwards',
};

export function groupFor(pos) {
  return POSITION_GROUP[pos] || 'MID';
}

// Whole-pounds figure → short, readable money. 2_400_000 → "£2.4m".
export function fmtMoney(n) {
  const v = Number(n);
  if (!Number.isFinite(v) || v === 0) return '—';
  const abs = Math.abs(v);
  if (abs >= 1_000_000) {
    const m = v / 1_000_000;
    return `£${(Math.abs(m) >= 10 ? Math.round(m) : m.toFixed(1)).toString().replace(/\.0$/, '')}m`;
  }
  if (abs >= 1_000) return `£${Math.round(v / 1_000)}k`;
  return `£${v}`;
}

// Age in whole years from an ISO date string, relative to today.
export function ageFromDob(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age -= 1;
  return age;
}

// "2027-06-30" → "Jun 2027"; passes through anything unparseable.
export function fmtContract(date) {
  if (!date) return '—';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return String(date);
  return d.toLocaleDateString('en-GB', { month: 'short', year: 'numeric' });
}

export function initialsFor(name) {
  if (!name) return '??';
  const words = name.replace(/\b(FC|AFC|United|Town|City|Rovers|Athletic|Borough|Wanderers)\b/gi, '')
    .trim().split(/\s+/).filter(Boolean);
  const src = words.length ? words : name.trim().split(/\s+/);
  return src.slice(0, 2).map((w) => w[0]).join('').toUpperCase() || name.slice(0, 2).toUpperCase();
}
